<template>
  <div>
    <div class="mb-2 text-right">
      <a v-if="!isLoading" @click="exportData" href="javascript:void(0)" class="border text-xs lg:text-sm px-4 py-1 mt-1 -mr-px whitespace-no-wrap bg-gray-200 hover:bg-white border-gray-400"><font-awesome-icon icon="download" ></font-awesome-icon> Export </a>
    </div>
    <div class="mb-2">
      <input-select class="col-span-4"
          v-model="submmissionCountFilter"
          :options="submmissionCountFilterOptions"
          :disabled="isLoading"
          label=""
          name="Submission Filter"
          placeholder="Application Used"
          return="value"
      />
    </div>
    <table class="w-full mb-4 internal-table">
        <thead>
          <tr class="">
            <th class="table-head-cell font-bold"><strong>Member Id</strong></th>
            <th class="table-head-cell font-bold"><strong>Name</strong></th>
            <th class="table-head-cell font-bold"><strong>Mobile Number</strong></th>
            <th class="table-head-cell font-bold"><strong>Date of Birth</strong></th>
            <th class="table-head-cell font-bold" style="text-align: center;"><strong>Submissions</strong></th>
            <th v-if="qrCode" class="table-head-cell font-bold" style="text-align: center;"><strong>Scanned</strong></th>
            <th class="table-head-cell font-bold"><strong>Actions</strong></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="member in filteredMembers">
            <tr class="text-xs">
              <td class="table-body-cell">{{member['member_id_display'] + ''}}</td>
              <td class="table-body-cell">{{member['first'] + ''}} {{member['last'] + ''}}</td>
              <td class="table-body-cell">{{member['mobile']}}</td>
              <td class="table-body-cell">{{member['date_of_birth']}}</td>
              <td class="table-body-cell text-center">{{member['submissions']}}</td>
              <td v-if="qrCode" class="table-body-cell text-center">
                <font-awesome-icon v-if="member.qr_scanned" class="text-lg text-green-500" icon="check" title="Scanned in" />
                <font-awesome-icon v-else class="text-lg text-red-500" icon="times" title="Not scanned in" />
              </td>
              <td class="flex items-center table-body-cell">
                <button @click="openSMSModal(member)" type="button" class="flex items-center justify-center px-2 py-2 outline-none has-tooltip text-gray-700" ><font-awesome-icon icon="paper-plane" ></font-awesome-icon></button>
                <router-link :to="'/members/' + member['id'] + '/view'" class="text-gray-700"><font-awesome-icon icon="eye"></font-awesome-icon></router-link>
              </td>
            </tr>
          </template>
          <tr v-if="isLoading">
            <td class="text-center" :colspan="qrCode ? 7 : 6">Please wait...</td>
          </tr>
        </tbody>
    </table>
    <SmsModal
      v-if="showSMSModal"
      @close="showSMSModal = false"
      @sent="showSMSModal = false"
      :to="sendTo"
      :id="rowID"
      :meta="SMSMeta"
      model="Member"
    />
  </div>
</template>
<script>
import axios from 'axios'
import SmsModal from '@/components/modals/SmsModal'

export default {
  name: 'MemberList',
  components: {
    SmsModal
  },
  props: {
    applicationFormId: String,
    qrCode: {
      type: Boolean,
      default: false
    }
  },
  mounted(){
    this.getData()
  },
  data(){
    return {
      isLoading: false,
      members: [],
      submmissionCountFilter: null,
      submmissionCountFilterOptions: [{
        label: 'All',
        value: null
      }, {
        label: 'Show Members with Submissions',
        value: 1
      }, {
        label: 'Show Members with no Submissions',
        value: 2
      }],
      sendTo: '',
      showSMSModal: false
    }
  },
  methods: {
    openSMSModal(member){
      this.sendTo = {
        name: `${member.first} ${member.last}`,
        number: member.mobile
      }
      this.rowID = member.id
      this.SMSMeta = {
        first: member.first,
        last: member.last,
      }
      this.showSMSModal = true;
    },
    getData(){
      this.isLoading = true
      this.members = []
      axios.post(process.env.VUE_APP_API_URL + '/application-forms/members', {
        application_form_id: this.applicationFormId,
      })
      .then(response => {
        this.isLoading = false
          this.members = response['data']
      })
    },
    exportData: function(){
        this.$store.commit('TOGGLE_BACKDROP', { open: true });

        let dataToExport = this.filteredMembers.map(member => {
          const row = {
            member_id: member['member_id_display'],
            first: member['first'],
            middle: member['middle'],
            last: member['last'],
            mobile: member['mobile'],
            date_of_birth: member['date_of_birth'],
            submission_count: member['submissions']
          }

          if (this.qrCode) {
            row.qr_scanned = member.qr_scanned ? 'Yes' : 'No'
          }

          return row
        })

        axios.post(process.env.VUE_APP_API_URL + '/export/application_form_members', {
            data: dataToExport
        }).then(response => {
            this.$store.commit('TOGGLE_BACKDROP', { open: false });

            this.$notify({
                group: 'main',
                position: 'top right',
                type: 'success',
                title: 'Success',
                text: 'Export generated successfully',
                duration: 5000
            });

            window.open(response.data);
        });
    },
  },
  computed: {
    filteredMembers(){
      const members = this.members.filter(member => {
        let hasPassed = true
        if(this.submmissionCountFilter){
          if(this.submmissionCountFilter === 1 && member['submissions'] === 0){ // has submission
            hasPassed = false
          }else if(this.submmissionCountFilter === 2 && member['submissions']){ // no submission
            hasPassed = false
          }
        }

        return hasPassed
      });

      this.$emit('members', members.length);
      return members;
    }
  }
}
</script>
